"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavHomeButtons = void 0;
var inversify_react_1 = require("inversify-react");
var react_1 = __importStar(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Navigation_1 = require("./Navigation");
var Telemetry_1 = require("@CommonFrontend/Telemetry");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var NavHomeButtons_css_1 = require("./NavHomeButtons.css");
var BetaTag_1 = require("Common/BetaTag/BetaTag");
var styles = __importStar(require("./Navigation.css"));
var LibraryContent_1 = require("./LibraryContent");
var LibraryDashboardType;
(function (LibraryDashboardType) {
    LibraryDashboardType["EngagementLibrary"] = "engagement-library";
    LibraryDashboardType["Templates"] = "templates";
    LibraryDashboardType["Automations"] = "automations";
    LibraryDashboardType["Payments"] = "payments";
})(LibraryDashboardType || (LibraryDashboardType = {}));
var c = (0, BemBuilder_1.default)(Navigation_1.BASE_CLASS_NAME);
var NavHomeButtons = function (_a) {
    var $state = _a.$state, hideBlocksButton = _a.hideBlocksButton, onPagesClick = _a.onPagesClick, activeNav = _a.activeNav, user = _a.user, rolesService = _a.rolesService, openBrandSetup = _a.openBrandSetup;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var isAdmin = rolesService.isAdmin(user);
    function goToAnalytics() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Analytics);
        $state.go("analytics");
    }
    function goToBlocks() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Blocks);
        $state.go("dashboard", { nav: "blocks" });
    }
    function goToLibraryDashboard(type) {
        $state.go("dashboard", { nav: type });
    }
    function goToPages() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Pages);
        if (onPagesClick) {
            onPagesClick();
        }
        else {
            $state.go("dashboard", { nav: "pages" });
        }
    }
    function goToReports() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Reports);
        $state.go("dashboard", { nav: "reports" });
    }
    function trackTabClicked(tabName) {
        telemetry.trackOnly(Telemetry_1.TelemetryEventName.NavigationTabClicked, { navigation_tab: tabName }, {
            blockIntercom: true,
        });
    }
    var libraryOptions = [];
    var optionMenuSize = "small";
    if (isAdmin) {
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                goToLibraryDashboard(LibraryDashboardType.Templates);
            }, icon: react_1.default.createElement(icons_1.Template, null) }, "Templates"));
    }
    if (!hideBlocksButton) {
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: goToBlocks, icon: react_1.default.createElement(icons_1.Blocks, null) }, "Blocks"));
    }
    if (isAdmin) {
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                goToLibraryDashboard(LibraryDashboardType.EngagementLibrary);
            }, icon: react_1.default.createElement(icons_1.Engagement, null) }, "Engagement"));
    }
    if (isAdmin && usingFeature(FeatureFlag_1.default.HubspotSyncEssentials)) {
        optionMenuSize = "large";
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                goToLibraryDashboard(LibraryDashboardType.Automations);
            }, icon: react_1.default.createElement(icons_1.Automation, null) },
            "Automations",
            " ",
            react_1.default.createElement("span", { className: NavHomeButtons_css_1.betaTag },
                react_1.default.createElement(BetaTag_1.BetaTag, null))));
    }
    var libraryOptionMenu = function () {
        return usingFeature(FeatureFlag_1.default.NewNavigation) ? (react_1.default.createElement(LibraryMenu, null)) : (react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(WrappedButton, { isActive: ["blocks", "templates", "automations"].includes(activeNav), isDropdown: true, syntheticsSelector: "nav-menu-library" }, "Library"), size: optionMenuSize, autoStack: true }, libraryOptions));
    };
    var libraryItems = [
        {
            displayName: "Blocks",
            description: "Reusable content blocks",
            icon: icons_1.Blocks,
            onClick: goToBlocks,
            hide: hideBlocksButton,
        },
        {
            displayName: "Themes",
            description: "Stay on Brand",
            icon: icons_1.StylesBrush,
            onClick: openBrandSetup,
        },
        {
            displayName: "Automations",
            description: "Automate workflows",
            icon: icons_1.Automation,
            onClick: function () { return goToLibraryDashboard(LibraryDashboardType.Automations); },
            featureFlag: FeatureFlag_1.default.HubspotSyncEssentials,
            hide: !isAdmin,
        },
        {
            displayName: "Templates",
            description: "Create and manage templates",
            icon: icons_1.Template,
            onClick: function () { return goToLibraryDashboard(LibraryDashboardType.Templates); },
            hide: !isAdmin,
        },
        {
            displayName: "Engagement scores",
            description: "Monitor page engagement",
            icon: icons_1.Engagement,
            onClick: function () { return goToLibraryDashboard(LibraryDashboardType.EngagementLibrary); },
            hide: !isAdmin,
        },
        {
            displayName: "Payments",
            description: "Manage page transactions",
            icon: icons_1.QwilrPayCircle,
            onClick: function () { return goToLibraryDashboard(LibraryDashboardType.Payments); },
            featureFlag: FeatureFlag_1.default.QwilrPay,
        },
    ];
    var LibraryMenu = function () {
        return (react_1.default.createElement(kaleidoscope_1.Popover, { size: kaleidoscope_1.PopoverSize.Auto, padding: "small", button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ className: styles.navButton, type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, decorator: kaleidoscope_1.ButtonDecorator.Dropdown }, buttonProps), "Library")); }, autoStack: true },
            react_1.default.createElement(LibraryContent_1.LibraryContent, { libraryItems: libraryItems })));
    };
    var renderLibraryOptions = function () {
        return libraryOptionMenu();
    };
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.navBarZIndex }, function () { return (react_1.default.createElement("div", { className: c("left") },
        react_1.default.createElement("div", { className: c("items") },
            react_1.default.createElement(AppHomePagesButton, { label: "Pages", activeNav: activeNav, navName: "pages", onClick: goToPages }),
            isAdmin && libraryOptions.length > 0 ? (renderLibraryOptions()) : (react_1.default.createElement(react_1.default.Fragment, null, !hideBlocksButton && (react_1.default.createElement(AppHomePagesButton, { label: "Blocks", activeNav: activeNav, navName: "blocks", onClick: goToBlocks })))),
            react_1.default.createElement(AppHomePagesButton, { label: "Reports", activeNav: activeNav, navName: "reports", onClick: goToReports })))); }));
};
exports.NavHomeButtons = NavHomeButtons;
var AppHomePagesButton = function (_a) {
    var label = _a.label, navName = _a.navName, activeNav = _a.activeNav, onClick = _a.onClick;
    var isActive = activeNav && activeNav === navName;
    return (react_1.default.createElement(WrappedButton, { syntheticsSelector: "nav-menu-".concat(navName), isActive: isActive, onClick: onClick }, label));
};
var WrappedButton = (0, react_1.forwardRef)(function navButton(_a, ref) {
    var isActive = _a.isActive, onClick = _a.onClick, children = _a.children, _b = _a.isDropdown, isDropdown = _b === void 0 ? false : _b, syntheticsSelector = _a.syntheticsSelector;
    return (react_1.default.createElement(kaleidoscope_1.Button, { innerRef: ref, className: styles.navButton, onClick: onClick, type: kaleidoscope_1.ButtonType.Tertiary, "aria-current": isActive, size: kaleidoscope_1.ButtonSize.Small, decorator: isDropdown ? kaleidoscope_1.ButtonDecorator.Dropdown : undefined, "data-synthetics-selector": syntheticsSelector }, children));
});
